document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".magnetic");

  buttons.forEach(button => {
    const strength = 14;

    button.addEventListener("mousemove", (e) => {
      const rect = button.getBoundingClientRect();
      const x = e.clientX - (rect.left + rect.width / 2);
      const y = e.clientY - (rect.top + rect.height / 2);

      button.style.transform = `translate(${x / strength}px, ${y / strength}px)`;
    });

    button.addEventListener("mouseleave", () => {
      button.style.transform = "translate(0, 0)";
    });
  });
});
document.addEventListener("DOMContentLoaded", () => {
  const isTouch = window.matchMedia("(hover: none)").matches;
  if (isTouch) return;

  document.querySelectorAll(".magnetic").forEach((el) => {
    const strength = 14;

    el.addEventListener("mousemove", (e) => {
      const r = el.getBoundingClientRect();
      const x = e.clientX - (r.left + r.width / 2);
      const y = e.clientY - (r.top + r.height / 2);

      el.style.transform = `translate3d(${x / strength}px, ${y / strength}px, 0)`;
    });

    el.addEventListener("mouseleave", () => {
      el.style.transform = "translate3d(0,0,0)";
    });
  });
});
